<section
    class="parameters-box d-flex flex-column w-100 h-100 pt-3 overflow-auto justify-content-start"
    [ngClass]="{ 'read-only': isDisabled }"
    *ngIf="parameters && parameters.length; else placeholderText"
>
    <div class="d-flex flex-column w-100 position-relative">
        <div *ngIf="isDisabled" class="overlay position-absolute h-100 w-100"></div>
        <ca-rerun-workflow-step-button
            [isActiveInStepByStep]="isActiveInStepByStep"
            (onReRunButtonClick)="reRunButtonClick()"
            [isDisabled]="isDisabled"
            [isFormValid]="formData.valid"
            [didParametersChange]="!formData.pristine"
            [isStepByStepRun]="isStepByStepRun"
        ></ca-rerun-workflow-step-button>
        <div *ngIf="!haveEditableParameters">
            <span class="p-2">{{ 'WORKFLOWS.MODULE_PARAMETERS.NO_EDITABLE_PARAMETERS' | translate }}</span>
        </div>

        <form *ngIf="haveEditableParameters" [formGroup]="formData" class="px-3 h-100">
            <section class="controls d-flex flex-column mb-4" *ngFor="let param of parameters; let i = index" data-uit="module-parameter-section">
                <ng-container *ngIf="shouldShowParamLabel(param)">
                    <label [for]="param.key" class="cursor-default font-m">
                        <span class="pe-2" [container]="'body'" placement="right" [ngbTooltip]="getParamTooltip(param)">{{ param.label }}</span>
                    </label>
                </ng-container>
                <div class="input-file-select" *ngIf="param.widget === 'input_file_select' || param.widget === 'file_dialog'">
                    <div class="input-group">
                        <input type="text" [formControlName]="param.key" readonly class="form-control" />
                        <button type="button" class="btn btn-secondary" [disabled]="isDisabled" (click)="openDefineInputDialog(param.inputType, param.key)">
                            <i class="fa fa-folder-open-o"></i>
                        </button>
                    </div>
                </div>
                <ng-container [ngSwitch]="param.widget">
                    <ca-slider
                        *ngSwitchCase="'slider'"
                        [minValue]="param.min"
                        [maxValue]="param.max"
                        [step]="param.step"
                        [formControlName]="param.key"
                        [type]="'single'"
                        [isDisabled]="isDisabled"
                        [manualRefresh]="manualSliderRefresh"
                        attr.data-uit="{{ 'input-parameter-slider-' + i }}"
                    ></ca-slider>
                    <ca-slider
                        *ngSwitchCase="'slider_range'"
                        [step]="param.step"
                        [minValue]="param.min"
                        [maxValue]="param.max"
                        [formControlName]="param.key"
                        [type]="'dual'"
                        [isDisabled]="isDisabled"
                        [manualRefresh]="manualSliderRefresh"
                    ></ca-slider>

                    <!-- Textbox for strings -->
                    <input
                        [id]="param.key"
                        type="text"
                        class="form-control"
                        [formControlName]="param.key"
                        *ngIf="param.key !== 'src_url' && param.widget === 'textbox' && !isInputTypeNumber(param.inputType)"
                        [placeholder]="param.label"
                    />
                    <!-- Textbox for numbers -->
                    <input
                        [id]="param.key"
                        type="number"
                        class="form-control"
                        [formControlName]="param.key"
                        *ngIf="param.key !== 'src_url' && param.widget === 'textbox' && isInputTypeNumber(param.inputType)"
                        [placeholder]="param.label"
                        [step]="param.step || 1"
                    />
                    <div caGroup class="radio-group field-select" *ngSwitchCase="'radiobuttongroup'" [formControlName]="param.key">
                        <div class="my-2" *ngFor="let radio of param.items">
                            <ca-input-radio [disabled]="isDisabled" [name]="'module-parameters-radio'" [value]="radio.key">
                                {{ radio.label }}
                            </ca-input-radio>
                        </div>
                    </div>
                    <ca-input-checkbox [id]="param.key" *ngSwitchCase="'checkbox'" [disabled]="isDisabled" [formControlName]="param.key">
                        {{ param.label }}
                    </ca-input-checkbox>
                    <ng-select
                        *ngSwitchCase="'dropdown'"
                        [items]="param.items"
                        [clearable]="false"
                        [formControlName]="param.key"
                        [searchable]="false"
                        bindValue="key"
                        bindLabel="label"
                        [readonly]="isDisabled"
                        [id]="param.key"
                    ></ng-select>
                </ng-container>
                <ng-container *ngIf="param.widget !== 'none'">
                    <small class="invalid-feedback" *ngFor="let errorKey of getErrorKeysFromModuleParameter(param)">
                        {{ getErrorMessage(errorKey, param) }}
                    </small>
                </ng-container>
            </section>
        </form>
    </div>
</section>
<ng-template #placeholderText>
    <ca-rerun-workflow-step-button
        [isActiveInStepByStep]="isActiveInStepByStep"
        (onReRunButtonClick)="reRunButtonClick()"
        [isDisabled]="isDisabled"
        [isFormValid]="formData.valid"
        [didParametersChange]="!formData.pristine"
        [isStepByStepRun]="isStepByStepRun"
    ></ca-rerun-workflow-step-button>
    <p class="p-3">{{ 'WORKFLOWS.MODULE_PARAMETERS.NO_PARAMETERS_AVAILABLE' | translate }}</p>
</ng-template>
